module.exports = __webpack_public_path__ + "img/22.271a2b96.png";